import Swal from 'sweetalert2';

export const TERMINAL_BLOCKED_STATUSES = new Set([3, 4, 7, 96, 97, 98, 99]);

export const REJECTION_REASON_STATUSES = new Set([3, 4]);

const DEFAULT_BLOCKED_MESSAGE = 'La solicitud no puede continuar en su estado actual.';

export const AUTOMATIC_REJECTION_FALLBACK =
  'La solicitud no cumple actualmente con los criterios de aprobación del producto.';

export const ANALYST_REJECTION_FALLBACK = 'Rechazo analista';

export const isRequestBlocked = (requestStatus) => {
  if (!requestStatus) {
    return false;
  }

  if (requestStatus.statusDetail?.canContinue === false) {
    return true;
  }

  return TERMINAL_BLOCKED_STATUSES.has(Number(requestStatus.status));
};

export const getRequestStatusMessage = (requestStatus) => {
  const status = Number(requestStatus?.status);

  if (status === 3) {
    return requestStatus?.rejection?.message || AUTOMATIC_REJECTION_FALLBACK;
  }

  if (status === 4) {
    return requestStatus?.rejection?.message
      || requestStatus?.statusDetail?.message
      || ANALYST_REJECTION_FALLBACK;
  }

  return requestStatus?.statusDetail?.message || DEFAULT_BLOCKED_MESSAGE;
};

export const getRequestRejectionDetail = (requestStatus) => {
  if (Number(requestStatus?.status) !== 4) {
    return null;
  }

  const detail = requestStatus?.rejection?.detail;

  if (typeof detail !== 'string') {
    return null;
  }

  const normalized = detail.trim();

  return normalized === '' ? null : normalized;
};

export const buildRequestStatusAlertContent = (message, detail) => {
  const wrap = document.createElement('div');

  const main = document.createElement('div');
  main.textContent = message;
  wrap.appendChild(main);

  if (detail) {
    const secondary = document.createElement('div');
    secondary.textContent = detail;
    secondary.style.marginTop = '8px';
    secondary.style.fontSize = '0.9em';
    secondary.style.opacity = '0.75';
    wrap.appendChild(secondary);
  }

  return wrap;
};

export const showRequestBlockedAlert = ({
  message = DEFAULT_BLOCKED_MESSAGE,
  detail = null,
  onViewRequests,
  onFatalError
} = {}) =>
  Swal.fire({
    icon: 'error',
    title: 'Solicitud rechazada',
    ...buildSwalBody(message, detail),
    confirmButtonText: 'Volver al perfil',
    showDenyButton: typeof onViewRequests === 'function',
    denyButtonText: 'Ver solicitudes',
    allowOutsideClick: false,
    allowEscapeKey: false
  }).then((result) => {
    if (result.isDenied && typeof onViewRequests === 'function') {
      onViewRequests();
      return;
    }

    if (typeof onFatalError === 'function') {
      onFatalError();
    }
  });

export const buildSwalBody = (message, detail) => {
  if (!detail) {
    return { text: message };
  }

  return { html: buildRequestStatusAlertContent(message, detail) };
};
